module.exports = __webpack_public_path__ + "src/app/_content/imgs/Cosy/bmw-cosySec.png?af416e2552ca5092e78343fbc9b17fe3";